// extracted by mini-css-extract-plugin
export default {"post":"Documents_post__e3Ymy","form":"Documents_form__l5hd5","button":"Documents_button__AQTLf","error":"Documents_error__5KJK-"};